export function validatePaidCheckData(data) {
  const percentageFields = [
    'audience_real_percentage',
    'audience_gender_male',
    'audience_gender_female',
    'audience_mass_followers_percentage',
    'audience_influencers_percentage',
    'audience_suspicious_percentage',
    'audience_age_13_17',
    'audience_age_18_24',
    'audience_age_25_34',
    'audience_age_35_44',
    'audience_age_45_plus',
    'monthly_growth_percentage',
    'sponsored_posts_percentage',
    'sponsored_reels_percentage'
  ];
  
  percentageFields.forEach(field => {
    const value = data[field];
    if (value != null && (typeof value !== 'number' || value < 0 || value > 100)) {
      data[field] = null;
    }
  });

  // Validate numeric fields that should be positive
  const positiveNumericFields = [
    'quality_score',
    'audience_median_age',
    'monthly_growth_followers',
    'avg_likes_per_post',
    'avg_comments_per_post',
    'posts_per_week',
    'reels_per_week',
  ];

  positiveNumericFields.forEach(field => {
    const value = data[field];
    if (value != null && (typeof value !== 'number' || value < 0)) {
      data[field] = null;
    }
  });

  // Validate string fields that should not be empty
  const stringFields = [
    'audience_city',
    'audience_language',
    'audience_countries_full',
    'audience_languages_full',
    'audience_cities_full',
    'audience_interests_full'
  ];

  stringFields.forEach(field => {
    const value = data[field];
    if (value != null && (typeof value !== 'string' || value.trim() === '')) {
      data[field] = null;
    }
  });

  return data;
} 